/**
 * Checks if the character is or belongs to a number.
 * [0-9]|+|-|.
 */
export function isDigitStart(code) {
    return ((code >= 48 && code <= 57) /* 0..9 */ || code === 0x2b /* + */ || code === 0x2d /* - */ || code === 0x2e); /* . */
}
export function isDigit(code) {
    return code >= 48 && code <= 57; // 0..9
}
//# sourceMappingURL=is-digit-start.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/layout/node_modules/@antv/util/esm/path/parser/is-digit-start.js
// module id = null
// module chunks = 